import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { AuthShell } from "@/components/AuthBits";

export default function ChangePassword() {
  const { user, setUser } = useAuth();
  const navigate = useNavigate();
  const [f, setF] = useState({ current: "", a: "", b: "" });
  const submit = async (e) => {
    e.preventDefault();
    if (f.a !== f.b) return toast.error("As senhas não são iguais.");
    try {
      const { data } = await api.post("/auth/change-password", { current_password: f.current, new_password: f.a });
      setUser(data);
      toast.success("Senha alterada!");
      navigate(data.is_admin ? "/admin" : "/perfil", { replace: true });
    } catch (err) { toast.error(errMsg(err)); }
  };
  const field = (k, label, testId) => (
    <div><label className="po-label" htmlFor={`cp-${k}`}>{label}</label>
      <input id={`cp-${k}`} type="password" required minLength={k === "current" ? 1 : 8} className="po-input" value={f[k]} onChange={(e) => setF({ ...f, [k]: e.target.value })} data-testid={testId} /></div>
  );
  return (
    <AuthShell title={user?.must_change_password ? "Troque sua senha" : "Alterar senha"} backTo="/perfil"
      subtitle={user?.must_change_password ? "Por segurança, crie uma senha nova antes de continuar." : undefined}>
      <form onSubmit={submit} className="space-y-4" data-testid="change-password-form">
        {user?.has_password && field("current", "Senha atual", "change-current-input")}
        {field("a", "Nova senha (mínimo 8 caracteres)", "change-new-input")}
        {field("b", "Repita a nova senha", "change-confirm-input")}
        <button className="po-btn-primary w-full" data-testid="change-password-submit">Salvar nova senha</button>
      </form>
    </AuthShell>
  );
}
